import axios from 'axios';
import services from '../config/services';
import { getErrorMessage } from '../utils/util.errors';
import {
	DELETE_USER,
	UPDATE_USER,
	GET_USERS,
	CREATE_USER,
	GET_ERRORS,
} from './types';


const URL_GETUSERS    = process.env.REACT_APP_API_URL + services.getUsers
const URL_ADDUSER     = process.env.REACT_APP_API_URL + services.addUser
const URL_PATCH_USER  = process.env.REACT_APP_API_URL + services.updateUser
const URL_DELETE_USER = process.env.REACT_APP_API_URL + services.deleteUser


export const getUsers = (skip, roles, filters) => dispatch => {

	let filterURL = URL_GETUSERS;

	filterURL += skip;

	filterURL += "?&limit=10";

	if (roles) {
		var filterRoles = '';
		for (let i = 0; i < roles.length; i++) {
			var row = roles[i]
			filterRoles += "&roles=" + row
		}
		filterURL += filterRoles
	}
	if (filters) {
		filterURL = filterURL + filters
	}

	axios
		.get(filterURL)
		.then(res => {
			dispatch({
				type: GET_USERS,
				payload: res.data
			})
		})
		.catch(error => {
			dispatch({
				type: GET_ERRORS,
				payload: getErrorMessage(error)
			})
		});
};

export const deleteUser = (id) => dispatch => {
	var URL = URL_DELETE_USER + id
	axios
		.delete(URL)
		.then(res => {
			dispatch({
				type: DELETE_USER,
				payload: {
					message: res.data.status.message
				}
			})
		})
		.catch(error => {
			dispatch({
				type: GET_ERRORS,
				payload: getErrorMessage(error)
			})
		});
}

export const updateUser = (id, nombre, innerBranchId, email, roles) => dispatch => {
	var data = {
		nombre: nombre,
		innerBranchId: innerBranchId,
		email: email,
		roles: roles
	}
	var URL = URL_PATCH_USER + id;
	axios.patch(URL, data)
		.then(res => {
			dispatch({
				type: UPDATE_USER,
				payload: res.data
			})
		})
		.catch(error => {
			dispatch({
				type: GET_ERRORS,
				payload: getErrorMessage(error)
			})
		});
}

export const updateAccess = (id, roles, faculties, denies) => dispatch => {
	var data = {
		roles: roles,
		faculties: faculties,
		denies: denies,
	}
	var URL = URL_PATCH_USER + id;
	axios.patch(URL, data)
		.then(res => {
			dispatch({
				type: UPDATE_USER,
				payload: res.data
			})
		})
		.catch(error => {
			dispatch({
				type: GET_ERRORS,
				payload: getErrorMessage(error)
			})
		});
}

export const addUser = (nombre, innerBranchId, roles, email, sendSMS, phoneNumber) => dispatch => {

		var data = {
			nombre: nombre,
			innerBranchId: innerBranchId,
			roles: roles,
			email: email,
			razonesSociales: [],
			sendSMS:sendSMS,
			phoneNumber:phoneNumber,
			denies:[],
			faculties:[]
		}
		axios
			.post(URL_ADDUSER, data)
			.then(res => {
				dispatch({
					type: CREATE_USER,
					payload: res.data
				})
			})
			.catch(error => {
				dispatch({
					type: GET_ERRORS,
					payload: getErrorMessage(error)
				})
			});
	}